import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logUpsellScrollStartedParams = {
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * User begins to scroll below the fold on any upsell screen.
 * @param params - Attributes to log with the amplitude event
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - Action that triggered the upsell to display
 */
const logUpsellScrollStarted = ({ purchase_screen_type_plan, trigger }: logUpsellScrollStartedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('upsell scroll started', { 'purchase screen type plan': purchase_screen_type_plan, trigger }, callback);
};

export default logUpsellScrollStarted;
